import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import GenericSelect from './GenericSelect';

const ISO_639_1_CODES = [
  'af','am','ar','az','be','bg','bn','bs','ca','cs','cy','da','de','el','en',
  'es','et','eu','fa','fi','fr','ga','gl','gu','ha','he','hi','hr','hu','hy',
  'id','is','it','ja','ka','kk','km','kn','ko','ku','ky','lb','lo','lt','lv',
  'mg','mi','mk','ml','mn','mr','ms','mt','my','nb','ne','nl','no','ny','pa',
  'pl','ps','pt','ro','ru','rw','sd','si','sk','sl','so','sq','sr','sv','sw',
  'ta','te','tg','th','tk','tl','tr','tt','ug','uk','ur','uz','vi','xh','yo',
  'zh','zu',
];

function buildLanguageOptions(appLocale) {
  const locale = ['tr', 'en', 'ru', 'kk', 'az'].includes(appLocale) ? appLocale : 'en';
  try {
    const displayNames = new Intl.DisplayNames([locale], { type: 'language' });
    return ISO_639_1_CODES
      .map((code) => {
        try {
          const name = displayNames.of(code);
          return { id: `${code.toUpperCase()} - ${name}`, name: `${code.toUpperCase()} - ${name}` };
        } catch {
          return null;
        }
      })
      .filter(Boolean)
      .sort((a, b) => a.name.localeCompare(b.name, locale));
  } catch {
    return ISO_639_1_CODES.map((code) => ({
      id: code.toUpperCase(),
      name: code.toUpperCase(),
    }));
  }
}

export default function LanguageSelect({ value, onChange, label, required, disabled, error, style }) {
  const { i18n } = useTranslation();
  const options = useMemo(() => buildLanguageOptions(i18n.language), [i18n.language]);

  return (
    <GenericSelect
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      idKey="id"
      labelKey="name"
      required={required}
      disabled={disabled}
      error={error}
      style={style}
    />
  );
}
